import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { getColorForValue } from '../../Utils/ColorUtils';
import CustomTooltip from '../../Utils/CustomTooltip';

// AdditionalMetricCard component for displaying metrics with a different layout:
// - Pie chart on the left and smaller
// - Title on the right top
// - Rationale under the title
const AdditionalMetricCard = ({ title, value, rationale, source, showSource = true }) => {
  // Parse value to ensure it's a number
  const numericValue = parseFloat(value) || 0;
  
  return (
    <div className="flex flex-col border border-gray-200 rounded-lg p-4 relative">
      {showSource && source && (
        <div className="absolute top-2 right-2">
          <CustomTooltip content={source} position="left">
            <span className="text-xs text-blue-600 cursor-help hover:text-blue-800 flex items-center">
              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Source
            </span>
          </CustomTooltip>
        </div>
      )}
      <div className="flex flex-row items-start mt-4">
        {/* Left side - Pie Chart */}
        <div className="flex-shrink-0 mr-4">
          <div className="relative w-32 h-32">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={[
                    { name: 'Value', value: numericValue * 10 },
                    { name: 'Remaining', value: 100 - (numericValue * 10) }
                  ]}
                  cx="50%"
                  cy="50%"
                  startAngle={90}
                  endAngle={-270}
                  innerRadius="60%"
                  outerRadius="80%"
                  dataKey="value"
                  cornerRadius={5}
                >
                  <Cell fill={getColorForValue(numericValue)} />
                  <Cell fill="#f3f4f6" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="text-3xl font-bold">{numericValue}</div>
              <div className="text-xs text-gray-500">/ 10</div>
            </div>
          </div>
        </div>
        
        {/* Right side - Title and Rationale */}
        <div className="flex-1">
          <h4 className="text-lg font-semibold text-gray-800 mb-2">{title}</h4>
          <p className="text-base text-gray-800">
            {rationale || "No rationale available."}
          </p>
        </div>
      </div>
    </div>
  );
};

AdditionalMetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rationale: PropTypes.string,
  source: PropTypes.string,
  showSource: PropTypes.bool
};

export default AdditionalMetricCard;
